<template>
  <section class="mt-5 flex flex-col gap-5">
    <p class="text-left text-body-color">
      {{ brokerName }} requires verification of your Cargo Insurance policy
      exclusions. Upload your entire Cargo Insurance policy so that Highway can
      verify your exclusions. This must be an
      <span class="font-semibold underline">unmodified PDF document</span> from
      your agency.
    </p>

    <div class="my-5 flex items-center justify-center">
      <img
        src="@/assets/cargo-banner.png"
        alt="Cargo Instructions"
      />
    </div>

    <section class="text-left">
      <label
        class="w-full text-left text-xxs font-bold uppercase text-dark-blue"
      >
        entire cargo policy document (required)
      </label>
      <div
        class="dropzone mt-2 flex flex-col items-center justify-center rounded-md py-4 text-gray-400"
        :class="{
          'border-yellow-500 bg-yellow-200 text-yellow-500': fileOverDropArea,
          'border-gray-200': !fileOverDropArea,
          'border border-dashed bg-off-white': !file,
        }"
        @drop.prevent="handleFileUpload($event)"
        @dragover.prevent
        @dragenter.prevent="fileOverDropArea = true"
        @dragleave.prevent="fileOverDropArea = false"
      >
        <template v-if="!file">
          <p class="text-gray-500">Drag and drop a PDF file or</p>
          <label
            for="file-upload"
            class="mt-2 cursor-pointer rounded-md border border-gray-over-dark px-4 py-2 text-xs text-body-color text-gray-over-dark hover:border-body-color active:border-dark-gray active:text-dark-gray"
          >
            Browse files
          </label>
          <input
            id="file-upload"
            type="file"
            accept=".pdf"
            class="hidden"
            @change="handleFileUpload($event)"
          />
        </template>
        <template v-else>
          <div class="w-full">
            <div
              class="flex items-center justify-between rounded-md border border-yellow-500 p-3"
            >
              <p class="text-dark-gray">
                {{ file.name || file.attachment_filename }}
              </p>
              <img
                class="ml-2 h-4 w-4 cursor-pointer hover:opacity-70"
                src="@/assets/trash-icon.svg"
                alt="delete"
                @click="deleteFile"
              />
            </div>
          </div>
        </template>
      </div>
    </section>
  </section>
</template>

<script setup>
import { ref, computed, defineEmits, defineProps, onMounted } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  cargoPolicy: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['fileUpload']);

onMounted(() => {
  if (props.cargoPolicy) {
    file.value = props.cargoPolicy;
  }
});

const file = ref(null);
const fileOverDropArea = ref(false);
const store = useStore();

const brokerName = computed(
  () => store.state.carriers.carrierData?.connection?.issuer?.legal_name || ''
);

const handleFileUpload = (event) => {
  const uploadedFile = event.target.files
    ? event.target.files[0]
    : event.dataTransfer.files[0];

  if (uploadedFile && uploadedFile.type === 'application/pdf') {
    file.value = uploadedFile;
    emit('fileUpload', file.value);
  }
  fileOverDropArea.value = false;
};

const deleteFile = () => {
  file.value = null;
  emit('fileUpload', null);
};
</script>
